var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramForeignCurrency48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./ForeignCurrency48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramHomeLoan48",
    transform: "translate(4.000000, 6.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    fill: "#FFCC00",
    cx: 10,
    cy: 26,
    r: 9.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pound",
    transform: "translate(6.500000, 21.500000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,8.25 L0,8.25 C0.683913739,8.25 1.3030557,7.97936193 1.75112398,7.54217736 C2.19919226,7.10499279 2.47656786,6.50088996 2.47656786,5.83358868 C2.47656786,5.1662874 2.19919226,4.56218457 1.75112398,4.125 C1.3030557,3.68781543 1.0256801,3.0837126 1.0256801,2.41641132 C1.0256801,1.74911004 1.3030557,1.14500721 1.75112398,0.707450883 C2.19919226,0.270266312 2.81833422,3.01980663e-14 3.50224796,3.01980663e-14 C4.1861617,3.01980663e-14 4.80530367,0.270266312 5.25337194,0.707450883 C5.70144022,1.14500721 5.97881582,1.74911004 5.97881582,2.41641132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,4.5 L4.5,4.5",
    id: "Arm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Yen-coin",
    transform: "translate(10.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Coin",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 9.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\xA5",
    transform: "translate(7.000000, 6.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,8.2967033 L3,3.2967033",
    id: "Arm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,4.72527473 L4.5,4.72527473",
    id: "Stem-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,6.86813187 L4.5,6.86813187",
    id: "Stem-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "V",
    points: "6 0.43956044 3 3.2967033 0 0.43956044"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Euro-coin",
    transform: "translate(20.000000, 15.250000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Coin",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10.75,
    r: 9.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Euro",
    transform: "translate(7.500000, 6.750000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3 L3,3",
    id: "Stem-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.25 L3,5.25",
    id: "Stem-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,8.25 L3.37353516,8.25 C1.92378769,8.25 0.744049072,7.31099363 0.744049072,6 L0.75,2.25 C0.75,0.93852191 1.92637142,-2.10942375e-14 3.37316895,-2.10942375e-14 L4.5,-2.10942375e-14",
    id: "Arm"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramForeignCurrency48);
export default __webpack_public_path__ + "static/media/pictogramForeignCurrency48.e631bf45ecced6b21dc13bb6e7bbf81b.svg";
export { ForwardRef as ReactComponent };